module.exports = __webpack_public_path__ + "static/media/installationTv.2e00094b.png";